<template>
	<div v-if="categoryEntries" class="relative overflow-hidden">
		<v-scrollable no-scrollbar class="relative">
			<div
				class="flex snap-x snap-proximity flex-nowrap space-x-4 md:space-x-6"
			>
				<v-scrollable-item
					v-for="(entry, index) in categoryEntries"
					:key="index"
					class="shrink-0 snap-start"
				>
					<nuxt-link
						:to="{path: route.path, query: {category: entry.value}}"
						class="group outline-hidden"
						:class="{
							'font-bold': isActive(entry.value),
							'font-normal': !isActive(entry.value),
						}"
					>
						<v-pill
							:theme="isActive(entry.value) ? 'secondary' : 'light'"
							padding="sm"
						>
							<span
								class="group-focus-visible:ring-2 group-focus-visible:ring-blue-600"
							>
								{{ entry.name }}
							</span>
						</v-pill>
					</nuxt-link>
				</v-scrollable-item>

				<v-scrollable-item class="w-4 shrink-0">
					<div />
				</v-scrollable-item>
			</div>
		</v-scrollable>

		<div
			class="absolute inset-y-0 right-0 w-30 bg-[linear-gradient(270deg,white_0,transparent_120px)]"
		/>
	</div>

	<div v-else class="invisible">...</div>
</template>

<script setup lang="ts">
import type {SbDatasourceEntry} from "@pkg/shared/types";

defineProps<{
	categoryEntries: SbDatasourceEntry[];
}>();

const route = useRoute();

function isActive(categoryValue: string): boolean {
	return (
		!!route.query.category && route.query.category.toString() === categoryValue
	);
}
</script>

<i18n lang="json">
{
	"et": {
		"recommended-articles": "Soovitatud artiklid"
	},
	"fi": {
		"recommended-articles": "Suositellut artikkelit"
	}
}
</i18n>
